var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-nam": "email",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.92v8.87a1.78 1.78 0 01-1.79 1.78H1.79a1.72 1.72 0 01-1.27-.52A1.71 1.71 0 010 15.79V6.92a5.94 5.94 0 001.13 1q4 2.74 5.54 3.85l1 .73a6.33 6.33 0 001 .53 3.29 3.29 0 001.23.28 3.29 3.29 0 001.34-.31 6.33 6.33 0 001-.53l1-.73q1.89-1.38 5.55-3.85a6.3 6.3 0 001.12-1zm0-3.28a2.93 2.93 0 01-.55 1.69 5.37 5.37 0 01-1.36 1.37l-5.22 3.63-.48.34-.6.42-.58.37a4 4 0 01-.64.3 2 2 0 01-.56.1 2 2 0 01-.56-.1 4 4 0 01-.64-.3l-.58-.37-.6-.42-.48-.34-2.92-2L1.92 6.7A5.49 5.49 0 01.61 5.41 2.59 2.59 0 010 3.89a2.23 2.23 0 01.46-1.45 1.59 1.59 0 011.33-.58h16.42a1.71 1.71 0 011.26.52A1.72 1.72 0 0120 3.64z"
  })));
};

export default SvgEmail;